// extracted by mini-css-extract-plugin
export default {"third_party_questionnarie_outer_div":"thirdPartyQuestionnarie_third_party_questionnarie_outer_div__4rtqt"};